import React from 'react';
import { formatDeliverySummary } from '../utils/deliveryDropoff';

export default function DeliveryOrderSummary({
  order,
  className = 'text-xs text-gray-600',
}: {
  order: {
    fulfillment_type?: string | null;
    delivery_address?: string | null;
    delivery_distance_km?: number | null;
    table_number?: number | null;
  };
  className?: string;
}) {
  if (String(order.fulfillment_type || '').toLowerCase() === 'dine_in') {
    const table = order.table_number;
    return (
      <p className={className}>
        Dine-in{table ? ` · Table ${table}` : ''}
      </p>
    );
  }
  const summary = formatDeliverySummary(order);
  if (!summary) return null;
  return <p className={className}>Delivery: {summary}</p>;
}
